import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import styles from './labelTemplate.styles';
import QRCode from 'qrcode.react';
import noimg from './images/noimg.png';
import { Grid } from '@material-ui/core';

export class LabelTemplate extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { classes, stockCode, rxNumbers } = this.props;
    const { picture_url, address } = this.props && this.props.pharmacyDetails;
    const accountdetails = this.props && this.props.accountDetails;
    const firstname = this.props && this.props.firstName;
    const lastname = this.props && this.props.lastName;
    const prefer_location_name = this.props && this.props.prefer_location_name;
    return (
      <div id='printableArea' className={classes.boxDesign}>
        {accountdetails && (
          <div className={classes.boxcontainer}>
            <div className={classes.boxLogo}>
              <img
                alt='logo'
                height='30px'
                width='40px'
                src={picture_url || noimg}
              />
            </div>
            <div className={classes.spacer}></div>
            <div className={classes.boxLogoDesc}>
              {accountdetails.name === 'null' ||
              accountdetails.name === 'undefined' ||
              accountdetails.name === undefined ||
              accountdetails.name === null ||
              accountdetails.name === ''
                ? ''
                : accountdetails.name}
              <br />
              {accountdetails.contact &&
                (accountdetails.contact.phone === 'null' ||
                accountdetails.contact.phone === 'undefined' ||
                accountdetails.contact.phone === undefined ||
                accountdetails.contact.phone === null ||
                accountdetails.contact.phone === ''
                  ? ''
                  : accountdetails.contact.phone)}
            </div>
          </div>
        )}
        {address && (
          <div className={classes.deliveryContainer}>
            Deliver to:
            <br />
            {/* { name === 'null' ||  name === 'undefined' ||  name === undefined ||  name === null ||  name === '' ? ''  : name }<br/> */}
            {prefer_location_name === 'null' ||
            prefer_location_name === 'undefined' ||
            prefer_location_name === undefined ||
            prefer_location_name === null ||
            prefer_location_name === ''
              ? ''
              : prefer_location_name}
            <br />
            {address.address_line_1 === 'null' ||
            address.address_line_1 === 'undefined' ||
            address.address_line_1 === undefined ||
            address.address_line_1 === null ||
            address.address_line_1 === ''
              ? ''
              : address.address_line_1.toString().concat(',')}
            {address.address_line_2 === 'null' ||
            address.address_line_2 === 'undefined' ||
            address.address_line_2 === undefined ||
            address.address_line_2 === null ||
            address.address_line_2 === ''
              ? ''
              : address.address_line_2}
            <br />
            {address.city === 'null' ||
            address.city === 'undefined' ||
            address.city === undefined ||
            address.city === null ||
            address.city === ''
              ? ''
              : address.city.toString().concat(',')}
            {address.state === 'null' ||
            address.state === 'undefined' ||
            address.state === undefined ||
            address.state === null ||
            address.state === ''
              ? ''
              : address.state.toString().concat(',')}
            {address.country === 'null' ||
            address.country === 'undefined' ||
            address.country === undefined ||
            address.country === null ||
            address.country === ''
              ? ''
              : address.country.toString().concat('-')}
            {address.zip === 'null' ||
            address.zip === 'undefined' ||
            address.zip === undefined ||
            address.zip === null ||
            address.zip === ''
              ? ''
              : address.zip}
          </div>
        )}
        <div className={classes.prescriptionContainer}>
          <Grid container>
            <Grid item xs={5}>
              {firstname && firstname.substring(0, 1)}
              {'.'}
              {lastname && lastname.substring(0, 3)}
              <br />
              Count ({rxNumbers && rxNumbers.length})<br />
              {rxNumbers &&
                rxNumbers.map((rnNo, index) => {
                  return (
                    <div key={index}>
                      {rnNo && rnNo.toString().toUpperCase()}
                    </div>
                  );
                })}
            </Grid>
            <Grid item xs={7}>
              <div className={classes.qrcodeContainer}>
                <QRCode
                  height='70px'
                  width='70px'
                  includeMargin={false}
                  renderAs={'svg'}
                  value={stockCode}
                />
                <br />
                <br />
              </div>
              <div className={classes.stockCode}>
                <h3 style={{ marginTop: '9vh' }}>{stockCode}</h3>
              </div>
            </Grid>
          </Grid>
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(LabelTemplate);



// WEBPACK FOOTER //
// ./src/components/console/labelTemplate.js